import React from "react";
import { useForgotPasswordVM } from "../viewmodels/ForgotPasswordVM";
import ForgotPasswordView from "../views/ForgotPasswordView";

const ForgotPasswordPage: React.FC = () => {
    const vm = useForgotPasswordVM();

    return <div>
        <ForgotPasswordView
            form={vm.form}
            errorMessages={vm.errorMessages}
            onValueChange={vm.setField}
            submit={vm.submit}
            loading={vm.loading}
            showConfirm={vm.showConfirm}
            setShowConfirm={vm.setShowConfirm}
        />
    </div>;
};

export default ForgotPasswordPage;